module.exports = __webpack_public_path__ + "assets/media/lunch.9252b4bf.mp3";